import { Container, useSlotRecipe } from '@chakra-ui/react';
import { DraggablePanelBodyProps } from '@components/ui/draggable/DraggablePanel';
import { forwardRef } from 'react';

export const Body = forwardRef<HTMLDivElement, DraggablePanelBodyProps>(
  ({ children, width = '100%', height, minHeight, maxHeight, ...rest }, ref) => {
    const { body } = useSlotRecipe({ key: 'draggablePanel' })();
    return (
      <Container
        ref={ref}
        {...rest}
        {...body}
        width={width}
        minHeight={minHeight ?? 'auto'}
        height={height !== undefined && minHeight !== undefined ? Math.max(height, minHeight) : (height ?? 'auto')}
        maxHeight={maxHeight}
      >
        {children}
      </Container>
    );
  },
);
